export const CUSTOMERS_OVERVIEWS_PAGE_SIZE = 1000;